module.exports = __webpack_public_path__ + "public/MoreSection/3.jpg?8cd7748b";